module.exports = __webpack_public_path__ + "media/images/donation/donation-background-791867d3470acf14a59a9ee084ae6f29.png";